import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackSpaPageView } from "@/lib/analytics";

export default function AnalyticsPageView() {
  const location = useLocation();

  useEffect(() => {
    trackSpaPageView();
  }, [location.hash, location.pathname, location.search]);

  return null;
}